import styled from 'styled-components';

/**
 * Fills the dual panel's body; `MainPanelRoot` provides the background and navbar clearance.
 * It does not scroll — the widget area inside does, so the header can stay outside the scroll.
 */
export const DashboardPanelSurface = styled.div`
  box-sizing: border-box;
  flex: 1;
  min-height: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;
